import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TemplateSheets from "./TemplateSheets";
import DatasetUpload from "./DatasetUpload";
import IconButton from "../../../packages/IconButton";
import CustomModal from "../../../packages/CustomModal";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../../utils/session";
import {
  FileExclamation,
  InfoCircle,
  QuestionIcon,
  UploadIcon,
} from "../../../assets/icons";
import {
  LOCAL_STORAGE_KEYS,
  TROUBLESHOOTING_TOPICS,
} from "../../../constants/global.constants";

const LeftPanel = ({
  fileInfo,
  uploadedFiles,
  totalTrainCount,
  selectedTrain,
  sheetNames,
  allTrainsStatus,
  setTempSelectedTrain,
  onRefreshTrainTabs,
}) => {
  const { t } = useTranslation();
  const [isTroubleshootingOpen, setIsTroubleshootingOpen] = useState(false);

  useEffect(() => {
    const troubleshootingReadTopics = JSON.parse(
      getLocalStorageItem(LOCAL_STORAGE_KEYS.TROUBLESHOOTING_READ_TOPICS) ||
        "[]",
    );

    if (
      !troubleshootingReadTopics.includes(TROUBLESHOOTING_TOPICS.DATASET_UPLOAD)
    ) {
      setIsTroubleshootingOpen(true);
    }
  }, []);

  const onTroubleshootingOpen = () => {
    setIsTroubleshootingOpen(true);
  };

  const onTroubleshootingClose = () => {
    const troubleshootingReadTopics = JSON.parse(
      getLocalStorageItem(LOCAL_STORAGE_KEYS.TROUBLESHOOTING_READ_TOPICS) ||
        "[]",
    );

    if (
      !troubleshootingReadTopics.includes(TROUBLESHOOTING_TOPICS.DATASET_UPLOAD)
    ) {
      const updatedTroubleshootingReadTopics = [
        ...troubleshootingReadTopics,
        TROUBLESHOOTING_TOPICS.DATASET_UPLOAD,
      ];
      setLocalStorageItem(
        LOCAL_STORAGE_KEYS.TROUBLESHOOTING_READ_TOPICS,
        JSON.stringify(updatedTroubleshootingReadTopics),
      );
    }

    setIsTroubleshootingOpen(false);
  };

  return (
    <div className="analyse-data-left-panel">
      <div className="ro-card-header">
        <div className="teal-heading">{t("analyseData.datasetUpload")}</div>
        <IconButton onClick={onTroubleshootingOpen}>
          <QuestionIcon />
        </IconButton>
      </div>
      <TemplateSheets />
      <DatasetUpload
        fileInfo={fileInfo}
        uploadedFiles={uploadedFiles}
        totalTrainCount={totalTrainCount}
        selectedTrain={selectedTrain}
        sheetNames={sheetNames}
        allTrainsStatus={allTrainsStatus}
        setTempSelectedTrain={setTempSelectedTrain}
        onRefreshTrainTabs={onRefreshTrainTabs}
      />

      {isTroubleshootingOpen && (
        <CustomModal
          header={
            <div className="dataset-troubleshoot-dialog__title">
              <span>{t("helpInformation.datasetTroubleshootTitle")}</span>
            </div>
          }
          onModalClose={onTroubleshootingClose}
          confirmBtn={t("ValueStrings.okay")}
          custombodyclass="dataset-troubleshoot-dialog__body"
          width="850px"
          hideCloseIcon
        >
          <div className="dataset-troubleshoot-dialog__grid">
            <div className="dataset-troubleshoot-dialog__column">
              <div className="dataset-troubleshoot-dialog__column-title">
                <FileExclamation className="dataset-troubleshoot-dialog__icon" />
                <span>
                  {t("helpInformation.datasetTroubleshootPrepareTemplate")}
                </span>
              </div>
              <ul className="dataset-troubleshoot-dialog__list">
                <li>
                  {t("helpInformation.datasetTroubleshootPrepareTemplate1")}
                </li>
                <li>
                  {t("helpInformation.datasetTroubleshootPrepareTemplate2")}
                </li>
                <li>
                  {t("helpInformation.datasetTroubleshootPrepareTemplate3")}
                </li>
              </ul>
            </div>

            <div className="dataset-troubleshoot-dialog__column">
              <div className="dataset-troubleshoot-dialog__column-title">
                <UploadIcon className="dataset-troubleshoot-dialog__icon" />
                <span>
                  {t("helpInformation.datasetTroubleshootUploadingData")}
                </span>
              </div>
              <ul className="dataset-troubleshoot-dialog__list">
                <li>
                  {t("helpInformation.datasetTroubleshootUploadingData1")}
                </li>
                <li>
                  {t("helpInformation.datasetTroubleshootUploadingData2")}
                </li>
                <li>
                  {t("helpInformation.datasetTroubleshootUploadingData3")}
                </li>
              </ul>
            </div>

            <div className="dataset-troubleshoot-dialog__column">
              <div className="dataset-troubleshoot-dialog__column-title">
                <InfoCircle className="dataset-troubleshoot-dialog__icon" />
                <span>
                  {t(
                    "helpInformation.datasetTroubleshootIfSomethingDoesntLoad",
                  )}
                </span>
              </div>
              <ul className="dataset-troubleshoot-dialog__list">
                <li>
                  {t(
                    "helpInformation.datasetTroubleshootIfSomethingDoesntLoad1",
                  )}
                </li>
                <li>
                  {t(
                    "helpInformation.datasetTroubleshootIfSomethingDoesntLoad2",
                  )}
                </li>
                <li>
                  {t(
                    "helpInformation.datasetTroubleshootIfSomethingDoesntLoad3",
                  )}
                </li>
                <li>
                  {t(
                    "helpInformation.datasetTroubleshootIfSomethingDoesntLoad4",
                  )}
                </li>
              </ul>
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default LeftPanel;
